<template>
    <div class="card shadow-sm">
        <div class="card-body">
            <h5 class="card-title">
                {{ $t("pages.admin.video.index.filter.filter") }}
            </h5>
            <div class="form-group">
                <label for="series-select" class="font-weight-bolder">{{
                    $t("pages.admin.video.index.filter.series")
                }}</label>
                <v-select
                    id="series-select"
                    :options="options"
                    :placeholder="
                        $t('pages.admin.video.index.filter.series_name')
                    "
                    @input="selectedSeries($event)"
                ></v-select>
            </div>
            <div class="form-group mt-2">
                <label for="video-title" class="font-weight-bolder">{{
                    $t("pages.admin.video.index.filter.video_title")
                }}</label>
                <input
                    type="text"
                    class="form-control"
                    id="video-title"
                    :placeholder="
                        $t('pages.admin.video.index.filter.video_title')
                    "
                    v-model="videoTitle"
                    @input="debounceVideoInput"
                />
            </div>
            <div
                class="alert alert-secondary border-dark mt-2"
                v-if="!anyFiltersSet"
            >
                {{ $t("pages.admin.video.index.filter.none_set") }}
            </div>
        </div>
    </div>
</template>

<script>
import SeriesSelection from "./SeriesSelection";
import AdminVideoRepository from "../../../../repositories/Admin/AdminVideoRepository";
import AdminSeriesRepository from "../../../../repositories/Admin/AdminSeriesRepository";
import _ from "lodash";

export default {
    name: "VideoFilter",
    components: { SeriesSelection },
    data: () => ({
        seriesList: [],
        series: null,
        videoTitle: null
    }),
    props: {
        videos: {
            type: Array,
            default: []
        }
    },

    mounted() {
        this.getVideos();
        this.getSeries();
    },
    methods: {
        debounceVideoInput: _.debounce(function() {
            this.getVideos();
        }, 300),
        selectedSeries(event) {
            if (event) {
                this.series = event.id;
                this.getVideos();
            } else {
                this.series = null;
                this.getVideos();
            }
        },
        getVideos(page = 1) {
            AdminVideoRepository.getVideos(
                page,
                this.series,
                this.videoTitle
            ).then(res => {
                this.$emit("update:videos", res.data.data);
                this.$emit("update:paginationData", res.data.meta);
            });
        },
        getSeries() {
            AdminSeriesRepository.getAllSeries(false).then(
                res => (this.seriesList = res.data)
            );
        },
        seriesSelectionChange(id) {
            if (this.series.includes(id)) {
                this.series = this.series.filter(sId => sId !== id);
            } else {
                this.series.push(id);
            }
        }
    },
    computed: {
        anyFiltersSet() {
            return this.series || this.videoTitle;
        },
        options() {
            let options = this.seriesList.map(series => {
                return { label: series.title.en + " (" + series.video_count + " Videos)", id: series.id };
            });
            options.unshift({ label: "Gym (No Series)", id: "null" });
            return options;
        }
    }
};
</script>

<style scoped></style>
